// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3wy06","logo":"header_logo__13VgX","hamburger":"header_hamburger__2QfH3"};